@file:Suppress("unused", "UNUSED_CHANGED_VALUE", "PropertyName", "FunctionName", "ClassName", "RedundantVisibilityModifier")

package com.steamstreet.vegasful.graphql.api.client

import com.steamstreet.dates.InstantSerializer
import com.steamstreet.graphkt.GraphKtQuery
import com.steamstreet.graphkt.ID
import com.steamstreet.graphkt.OptionalInput
import com.steamstreet.graphkt.client.GraphQLClient
import com.steamstreet.graphkt.client.QueryWriter
import com.steamstreet.vegasful.graphql.api.AWSDate
import com.steamstreet.vegasful.graphql.api.AWSDateTime
import com.steamstreet.vegasful.graphql.api.ArticleInput
import com.steamstreet.vegasful.graphql.api.ArticleSearchInput
import com.steamstreet.vegasful.graphql.api.ClearUserDataInput
import com.steamstreet.vegasful.graphql.api.ConversationInput
import com.steamstreet.vegasful.graphql.api.CreateAnonymousInput
import com.steamstreet.vegasful.graphql.api.DeviceTokenRegistration
import com.steamstreet.vegasful.graphql.api.EventSearch
import com.steamstreet.vegasful.graphql.api.EventStream
import com.steamstreet.vegasful.graphql.api.EventUpdateInput
import com.steamstreet.vegasful.graphql.api.GlobalSearchInput
import com.steamstreet.vegasful.graphql.api.ImageUpload
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import com.steamstreet.vegasful.graphql.api.LikeInput
import com.steamstreet.vegasful.graphql.api.LoaderConfiguration
import com.steamstreet.vegasful.graphql.api.LoaderExecutionInput
import com.steamstreet.vegasful.graphql.api.LoaderPublishInput
import com.steamstreet.vegasful.graphql.api.LogQueryInput
import com.steamstreet.vegasful.graphql.api.MergeInput
import com.steamstreet.vegasful.graphql.api.PerformerSearch
import com.steamstreet.vegasful.graphql.api.PerformerUpdateInput
import com.steamstreet.vegasful.graphql.api.RefreshTokenInput
import com.steamstreet.vegasful.graphql.api.ShareInput
import com.steamstreet.vegasful.graphql.api.SocialImageDateStyle
import com.steamstreet.vegasful.graphql.api.SocialImageRenderer
import com.steamstreet.vegasful.graphql.api.SubscriptionInput
import com.steamstreet.vegasful.graphql.api.SystemEventInput
import com.steamstreet.vegasful.graphql.api.TagUpdateInput
import com.steamstreet.vegasful.graphql.api.ThingSearch
import com.steamstreet.vegasful.graphql.api.ThingUpdateInput
import com.steamstreet.vegasful.graphql.api.VariantInput
import com.steamstreet.vegasful.graphql.api.VenueUpdateInput
import com.steamstreet.vegasful.graphql.api.ViewQuery
import com.steamstreet.vegasful.graphql.api.json
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.datetime.serializers.LocalDateIso8601Serializer
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.nullable
import kotlinx.serialization.serializer

@GraphKtQuery
public class _AccountQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val createDate: Unit
    get() {
      writer.println("createDate")
    }

  public fun registerDevice(input: DeviceTokenRegistration) {
    writer.print("registerDevice")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "DeviceTokenRegistration!", serializer<DeviceTokenRegistration>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun unregisterDevice(input: DeviceTokenRegistration) {
    writer.print("unregisterDevice")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "DeviceTokenRegistration!", serializer<DeviceTokenRegistration>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }
}

@GraphKtQuery
public class _AccountsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun createAnonymous(input: CreateAnonymousInput, _selection: _CreateAccountResponseQuery.() -> Unit) {
    writer.print("createAnonymous")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "CreateAnonymousInput!", serializer<CreateAnonymousInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _CreateAccountResponseQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun me(_selection: _AccountQuery.() -> Unit) {
    writer.print("me")
    writer.println(" {")
    writer.indent {
      _AccountQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun refresh(input: RefreshTokenInput, _selection: _CreateAccountResponseQuery.() -> Unit) {
    writer.print("refresh")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "RefreshTokenInput!", serializer<RefreshTokenInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _CreateAccountResponseQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AddressQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val city: Unit
    get() {
      writer.println("city")
    }

  public val country: Unit
    get() {
      writer.println("country")
    }

  public val state: Unit
    get() {
      writer.println("state")
    }

  public val street: Unit
    get() {
      writer.println("street")
    }

  public val zip: Unit
    get() {
      writer.println("zip")
    }
}

@GraphKtQuery
public class _AdminArticleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val created: Unit
    get() {
      writer.println("created")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val published: Unit
    get() {
      writer.println("published")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val updated: Unit
    get() {
      writer.println("updated")
    }

  public fun delete(confirmation: Boolean) {
    writer.print("delete")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("confirmation: ${'$'}")
    writer.print(writer.variable("confirmation", "Boolean!", confirmation))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _EntityQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun publish(time: OptionalInput<AWSDateTime?> = OptionalInput.Absent, _selection: _AdminArticleQuery.() -> Unit) {
    writer.print("publish")
    var _graphKtArgumentWritten = false
    when (val value = time) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("time: ${'$'}")
        writer.print(writer.variable("time", "AWSDateTime", InstantSerializer.nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun resolvedLinks(_selection: _EntityQuery.() -> Unit) {
    writer.print("resolvedLinks")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun unpublish(_selection: _AdminArticleQuery.() -> Unit) {
    writer.print("unpublish")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: ArticleInput, _selection: _AdminArticleQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ArticleInput!", serializer<ArticleInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminArticlesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun article(id: ID, _selection: _AdminArticleQuery.() -> Unit) {
    writer.print("article")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun content(id: ID, _selection: _AdminArticleQuery.() -> Unit) {
    writer.print("content")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun drafts(_selection: _AdminArticleQuery.() -> Unit) {
    writer.print("drafts")
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun new(
    id: OptionalInput<ID?> = OptionalInput.Absent,
    input: ArticleInput,
    _selection: _AdminArticleQuery.() -> Unit,
  ) {
    writer.print("new")
    var _graphKtArgumentWritten = false
    when (val value = id) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("id: ${'$'}")
        writer.print(writer.variable("id", "ID", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ArticleInput!", serializer<ArticleInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminArticleQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminEventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val activatedTs: Unit
    get() {
      writer.println("activatedTs")
    }

  public val deactivatedTs: Unit
    get() {
      writer.println("deactivatedTs")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun children(_selection: _EventQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun disable(delete: Boolean) {
    writer.print("disable")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("delete: ${'$'}")
    writer.print(writer.variable("delete", "Boolean!", delete))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun generateSocialImage(
    renderer: SocialImageRenderer,
    dateStyle: OptionalInput<SocialImageDateStyle> = OptionalInput.Absent,
    omitTime: OptionalInput<Boolean> = OptionalInput.Absent,
    includeTagline: OptionalInput<Boolean> = OptionalInput.Absent,
    includeVenue: OptionalInput<Boolean> = OptionalInput.Absent,
    forceCover: OptionalInput<Boolean> = OptionalInput.Absent,
  ) {
    writer.print("generateSocialImage")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("renderer: ${'$'}")
    writer.print(writer.variable("renderer", "SocialImageRenderer!", serializer<SocialImageRenderer>(), renderer))
    when (val value = dateStyle) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("dateStyle: ${'$'}")
        writer.print(writer.variable("dateStyle", "SocialImageDateStyle!", serializer<SocialImageDateStyle>(), value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = omitTime) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("omitTime: ${'$'}")
        writer.print(writer.variable("omitTime", "Boolean!", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = includeTagline) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("includeTagline: ${'$'}")
        writer.print(writer.variable("includeTagline", "Boolean!", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = includeVenue) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("includeVenue: ${'$'}")
        writer.print(writer.variable("includeVenue", "Boolean!", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = forceCover) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("forceCover: ${'$'}")
        writer.print(writer.variable("forceCover", "Boolean!", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun layer(id: ID, _selection: _AdminEventLayerQuery.() -> Unit) {
    writer.print("layer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layers(_selection: _AdminEventLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun local(_selection: _AdminEventLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _EventQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun rebuild(message: OptionalInput<String?> = OptionalInput.Absent) {
    writer.print("rebuild")
    var _graphKtArgumentWritten = false
    when (val value = message) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("message: ${'$'}")
        writer.print(writer.variable("message", "String", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun resolved(_selection: _EventQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun review(input: EventUpdateInput) {
    writer.print("review")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventUpdateInput!", serializer<EventUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun socialImageStatus(url: String, _selection: _SocialImageStatusQuery.() -> Unit) {
    writer.print("socialImageStatus")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("url: ${'$'}")
    writer.print(writer.variable("url", "String!", url))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _SocialImageStatusQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminEventLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val excluded: Unit
    get() {
      writer.println("excluded")
    }

  public val expiration: Unit
    get() {
      writer.println("expiration")
    }

  public val lastUpdated: Unit
    get() {
      writer.println("lastUpdated")
    }

  public val layerId: Unit
    get() {
      writer.println("layerId")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val suggestedPerformers: Unit
    get() {
      writer.println("suggestedPerformers")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public fun excludedImages(_selection: _ImageQuery.() -> Unit) {
    writer.print("excludedImages")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun excludedTags(_selection: _TagQuery.() -> Unit) {
    writer.print("excludedTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: EventUpdateInput, _selection: _AdminEventLayerQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventUpdateInput!", serializer<EventUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminEventLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(_selection: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminEventsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun add(input: EventUpdateInput, _selection: _AdminEventQuery.() -> Unit) {
    writer.print("add")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventUpdateInput!", serializer<EventUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun enhance(
    id: ID,
    apply: Boolean,
    _selection: _EventUpdateQuery.() -> Unit,
  ) {
    writer.print("enhance")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("apply: ${'$'}")
    writer.print(writer.variable("apply", "Boolean!", apply))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventUpdateQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun event(id: ID, _selection: _AdminEventQuery.() -> Unit) {
    writer.print("event")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun forReview(_selection: _EventQuery.() -> Unit) {
    writer.print("forReview")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun merge(input: MergeInput, _selection: _AdminEventQuery.() -> Unit) {
    writer.print("merge")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "MergeInput!", serializer<MergeInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun reviewNext(_selection: _AdminEventQuery.() -> Unit) {
    writer.print("reviewNext")
    writer.println(" {")
    writer.indent {
      _AdminEventQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminImagesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun upload(input: ImageUpload, _selection: _ImageQuery.() -> Unit) {
    writer.print("upload")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ImageUpload!", serializer<ImageUpload>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminLoaderQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val parameters: Unit
    get() {
      writer.println("parameters")
    }

  public val reprocess: Unit
    get() {
      writer.println("reprocess")
    }

  public val schedule: Unit
    get() {
      writer.println("schedule")
    }

  public fun execute(input: OptionalInput<LoaderExecutionInput?> = OptionalInput.Absent) {
    writer.print("execute")
    var _graphKtArgumentWritten = false
    when (val value = input) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("input: ${'$'}")
        writer.print(writer.variable("input", "LoaderExecutionInput", serializer<LoaderExecutionInput>().nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun lastLoad(_selection: _LoaderExecutionQuery.() -> Unit) {
    writer.print("lastLoad")
    writer.println(" {")
    writer.indent {
      _LoaderExecutionQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun logs(
    start: AWSDateTime,
    end: AWSDateTime,
    _selection: _LogEventQuery.() -> Unit,
  ) {
    writer.print("logs")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("start: ${'$'}")
    writer.print(writer.variable("start", "AWSDateTime!", InstantSerializer, start))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("end: ${'$'}")
    writer.print(writer.variable("end", "AWSDateTime!", InstantSerializer, end))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _LogEventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun module(_selection: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("module")
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun publish(input: LoaderPublishInput) {
    writer.print("publish")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "LoaderPublishInput!", serializer<LoaderPublishInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun readInternalData(key: String) {
    writer.print("readInternalData")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("key: ${'$'}")
    writer.print(writer.variable("key", "String!", key))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun recentExecutions(_selection: _LoaderExecutionQuery.() -> Unit) {
    writer.print("recentExecutions")
    writer.println(" {")
    writer.indent {
      _LoaderExecutionQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun saveInternalData(key: String, `data`: String) {
    writer.print("saveInternalData")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("key: ${'$'}")
    writer.print(writer.variable("key", "String!", key))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("data: ${'$'}")
    writer.print(writer.variable("data", "String!", `data`))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun update(input: LoaderConfiguration, _selection: _AdminLoaderQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "LoaderConfiguration!", serializer<LoaderConfiguration>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminLoaderModuleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }
}

@GraphKtQuery
public class _AdminLoadersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun deregister(id: ID) {
    writer.print("deregister")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun loader(id: ID, _selection: _AdminLoaderQuery.() -> Unit) {
    writer.print("loader")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun loaders(_selection: _AdminLoaderQuery.() -> Unit) {
    writer.print("loaders")
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun module(id: ID, _selection: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("module")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun modules(_selection: _AdminLoaderModuleQuery.() -> Unit) {
    writer.print("modules")
    writer.println(" {")
    writer.indent {
      _AdminLoaderModuleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun registerLoader(
    id: ID,
    input: LoaderConfiguration,
    _selection: _AdminLoaderQuery.() -> Unit,
  ) {
    writer.print("registerLoader")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "LoaderConfiguration!", serializer<LoaderConfiguration>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminLoaderQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminLogsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun results(queryId: ID, _selection: _LogQueryResultQuery.() -> Unit) {
    writer.print("results")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("queryId: ${'$'}")
    writer.print(writer.variable("queryId", "ID!", queryId))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _LogQueryResultQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun startQuery(input: LogQueryInput) {
    writer.print("startQuery")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "LogQueryInput!", serializer<LogQueryInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }
}

@GraphKtQuery
public class _AdminMutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val domain: Unit
    get() {
      writer.println("domain")
    }

  public fun articles(_selection: _AdminArticlesQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _AdminArticlesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(_selection: _AdminEventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _AdminEventsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _AdminImagesQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _AdminImagesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun loaders(_selection: _AdminLoadersQuery.() -> Unit) {
    writer.print("loaders")
    writer.println(" {")
    writer.indent {
      _AdminLoadersQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun logs(_selection: _AdminLogsQuery.() -> Unit) {
    writer.print("logs")
    writer.println(" {")
    writer.indent {
      _AdminLogsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _AdminPerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _AdminPerformersQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _AdminTagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _AdminTagsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun thingsToDo(_selection: _AdminThingsToDoQuery.() -> Unit) {
    writer.print("thingsToDo")
    writer.println(" {")
    writer.indent {
      _AdminThingsToDoQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venues(_selection: _AdminVenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _AdminVenuesQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminPerformerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun layer(id: ID, _selection: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("layer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layers(_selection: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun local(_selection: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun resolved(_selection: _PerformerQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminPerformerLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val wikiIdentifier: Unit
    get() {
      writer.println("wikiIdentifier")
    }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: PerformerUpdateInput, _selection: _AdminPerformerLayerQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "PerformerUpdateInput!", serializer<PerformerUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminPerformerLayerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminPerformersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun add(
    id: ID,
    input: PerformerUpdateInput,
    _selection: _AdminPerformerQuery.() -> Unit,
  ) {
    writer.print("add")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "PerformerUpdateInput!", serializer<PerformerUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminPerformerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun enhance(
    id: ID,
    apply: Boolean,
    _selection: _PerformerUpdateQuery.() -> Unit,
  ) {
    writer.print("enhance")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("apply: ${'$'}")
    writer.print(writer.variable("apply", "Boolean!", apply))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _PerformerUpdateQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performer(id: ID, _selection: _AdminPerformerQuery.() -> Unit) {
    writer.print("performer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminPerformerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminTagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun children(_selection: _TagQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layer(id: ID, _selection: _AdminTagLayerQuery.() -> Unit) {
    writer.print("layer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layers(_selection: _AdminTagLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun local(_selection: _AdminTagLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun resolved(_selection: _TagQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminTagLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aiPromptInput: Unit
    get() {
      writer.println("aiPromptInput")
    }

  public val childLimit: Unit
    get() {
      writer.println("childLimit")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val pageTitle: Unit
    get() {
      writer.println("pageTitle")
    }

  public val personalize: Unit
    get() {
      writer.println("personalize")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val shadow: Unit
    get() {
      writer.println("shadow")
    }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun impliedTags(_selection: _TagQuery.() -> Unit) {
    writer.print("impliedTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: TagUpdateInput, _selection: _AdminTagLayerQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "TagUpdateInput!", serializer<TagUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminTagLayerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminTagsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun add(
    id: ID,
    input: TagUpdateInput,
    _selection: _AdminTagQuery.() -> Unit,
  ) {
    writer.print("add")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "TagUpdateInput!", serializer<TagUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun all(_selection: _AdminTagQuery.() -> Unit) {
    writer.print("all")
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tag(id: ID, _selection: _AdminTagQuery.() -> Unit) {
    writer.print("tag")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminTagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminThingLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val hours: Unit
    get() {
      writer.println("hours")
    }

  public val hoursSources: Unit
    get() {
      writer.println("hoursSources")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val priceFrom: Unit
    get() {
      writer.println("priceFrom")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val typicalDuration: Unit
    get() {
      writer.println("typicalDuration")
    }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: ThingUpdateInput, _selection: _AdminThingLayerQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ThingUpdateInput!", serializer<ThingUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminThingLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(_selection: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminThingToDoQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val delete: Unit
    get() {
      writer.println("delete")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun layer(id: ID, _selection: _AdminThingLayerQuery.() -> Unit) {
    writer.print("layer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminThingLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layers(_selection: _AdminThingLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminThingLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun local(_selection: _AdminThingLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminThingLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun resolved(_selection: _ThingToDoQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _ThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminThingsToDoQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun add(
    id: ID,
    input: ThingUpdateInput,
    _selection: _AdminThingToDoQuery.() -> Unit,
  ) {
    writer.print("add")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ThingUpdateInput!", serializer<ThingUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun all(_selection: _AdminThingToDoQuery.() -> Unit) {
    writer.print("all")
    writer.println(" {")
    writer.indent {
      _AdminThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun thing(id: ID, _selection: _AdminThingToDoQuery.() -> Unit) {
    writer.print("thing")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenueQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun children(_selection: _VenueQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layer(id: ID, _selection: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("layer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun layers(_selection: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("layers")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun local(_selection: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("local")
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _VenueQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun resolved(_selection: _VenueQuery.() -> Unit) {
    writer.print("resolved")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenueLayerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val contentView: Unit
    get() {
      writer.println("contentView")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val eventStream: Unit
    get() {
      writer.println("eventStream")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public fun address(_selection: _AddressQuery.() -> Unit) {
    writer.print("address")
    writer.println(" {")
    writer.indent {
      _AddressQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun location(_selection: _GPSCoordinatesQuery.() -> Unit) {
    writer.print("location")
    writer.println(" {")
    writer.indent {
      _GPSCoordinatesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun redirect(_selection: _VenueQuery.() -> Unit) {
    writer.print("redirect")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun update(input: VenueUpdateInput, _selection: _AdminVenueLayerQuery.() -> Unit) {
    writer.print("update")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "VenueUpdateInput!", serializer<VenueUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminVenueLayerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AdminVenuesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun add(
    id: ID,
    input: VenueUpdateInput,
    _selection: _AdminVenueQuery.() -> Unit,
  ) {
    writer.print("add")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "VenueUpdateInput!", serializer<VenueUpdateInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminVenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(id: ID, _selection: _AdminVenueQuery.() -> Unit) {
    writer.print("venue")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _AdminVenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticleQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val created: Unit
    get() {
      writer.println("created")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val published: Unit
    get() {
      writer.println("published")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val updated: Unit
    get() {
      writer.println("updated")
    }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun linkedEntities(_selection: _EntityQuery.() -> Unit) {
    writer.print("linkedEntities")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticleSearchResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun articles(_selection: _ArticleQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _ArticleQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ArticlesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun article(id: ID, _selection: _ArticleQuery.() -> Unit) {
    writer.print("article")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ArticleQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun query(input: ArticleSearchInput, _selection: _ArticleSearchResultQuery.() -> Unit) {
    writer.print("query")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ArticleSearchInput!", serializer<ArticleSearchInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ArticleSearchResultQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun recent(input: ArticleSearchInput, _selection: _ArticleSearchResultQuery.() -> Unit) {
    writer.print("recent")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ArticleSearchInput!", serializer<ArticleSearchInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ArticleSearchResultQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AuxContentQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun features(_selection: _AuxFeaturesQuery.() -> Unit) {
    writer.print("features")
    writer.println(" {")
    writer.indent {
      _AuxFeaturesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun onboarding(_selection: _OnboardingQuery.() -> Unit) {
    writer.print("onboarding")
    writer.println(" {")
    writer.indent {
      _OnboardingQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _AuxFeaturesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun feature(
    id: ID,
    input: OptionalInput<ViewQuery?> = OptionalInput.Absent,
    _selection: _ViewConfigurationQuery.() -> Unit,
  ) {
    writer.print("feature")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    when (val value = input) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("input: ${'$'}")
        writer.print(writer.variable("input", "ViewQuery", serializer<ViewQuery>().nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ClientSupportQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun logClientEvent(`data`: String) {
    writer.print("logClientEvent")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("data: ${'$'}")
    writer.print(writer.variable("data", "String!", `data`))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun onboarding(_selection: _OnboardingQuery.() -> Unit) {
    writer.print("onboarding")
    writer.println(" {")
    writer.indent {
      _OnboardingQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun entities(path: List<String>, _selection: _EntityQuery.() -> Unit) {
    writer.print("entities")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("path: ${'$'}")
    writer.print(writer.variable("path", "[String!]!", ListSerializer(serializer<String>()), path))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(_selection: _EventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _PerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformersQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venues(_selection: _VenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenuesQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentPanelQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val articleSource: Unit
    get() {
      writer.println("articleSource")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val displayOrder: Unit
    get() {
      writer.println("displayOrder")
    }

  public val entitiesSource: Unit
    get() {
      writer.println("entitiesSource")
    }

  public val flags: Unit
    get() {
      writer.println("flags")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val maxWidth: Unit
    get() {
      writer.println("maxWidth")
    }

  public val minWidth: Unit
    get() {
      writer.println("minWidth")
    }

  public val subTitle: Unit
    get() {
      writer.println("subTitle")
    }

  public val subTitleLink: Unit
    get() {
      writer.println("subTitleLink")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val titleLink: Unit
    get() {
      writer.println("titleLink")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }

  public fun entities(_selection: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun entityFilters(_selection: _EntityQuery.() -> Unit) {
    writer.print("entityFilters")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun filterTags(_selection: _TagQuery.() -> Unit) {
    writer.print("filterTags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _ContentViewLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _ContentViewLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun source(_selection: _PanelSourceQuery.() -> Unit) {
    writer.print("source")
    writer.println(" {")
    writer.indent {
      _PanelSourceQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val content: Unit
    get() {
      writer.println("content")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _ContentViewLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _ContentViewLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun sections(_selection: _ContentViewSectionQuery.() -> Unit) {
    writer.print("sections")
    writer.println(" {")
    writer.indent {
      _ContentViewSectionQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewEntityQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val action: Unit
    get() {
      writer.println("action")
    }

  public val containerName: Unit
    get() {
      writer.println("containerName")
    }

  public val containerPath: Unit
    get() {
      writer.println("containerPath")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewLinkQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }
}

@GraphKtQuery
public class _ContentViewSectionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val contentHtml: Unit
    get() {
      writer.println("contentHtml")
    }

  public val link: Unit
    get() {
      writer.println("link")
    }

  public val source: Unit
    get() {
      writer.println("source")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }

  public fun content(_selection: _ContentViewEntityQuery.() -> Unit) {
    writer.print("content")
    writer.println(" {")
    writer.indent {
      _ContentViewEntityQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ContentViewsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun byId(
    id: ID,
    input: OptionalInput<ViewQuery?> = OptionalInput.Absent,
    _selection: _ViewConfigurationQuery.() -> Unit,
  ) {
    writer.print("byId")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    when (val value = input) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("input: ${'$'}")
        writer.print(writer.variable("input", "ViewQuery", serializer<ViewQuery>().nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun view(id: String, _selection: _ContentViewQuery.() -> Unit) {
    writer.print("view")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "String!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ContentViewQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ConversationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val response: Unit
    get() {
      writer.println("response")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public fun panels(_selection: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun turns(_selection: _ConversationTurnQuery.() -> Unit) {
    writer.print("turns")
    writer.println(" {")
    writer.indent {
      _ConversationTurnQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ConversationTurnQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val query: Unit
    get() {
      writer.println("query")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public fun panels(_selection: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ConversationsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun conversation(id: ID, _selection: _ConversationQuery.() -> Unit) {
    writer.print("conversation")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ConversationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun start(input: ConversationInput, _selection: _ConversationQuery.() -> Unit) {
    writer.print("start")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ConversationInput!", serializer<ConversationInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ConversationQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _CreateAccountResponseQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val token: Unit
    get() {
      writer.println("token")
    }
}

@GraphKtQuery
public class _DateRangeQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val from: Unit
    get() {
      writer.println("from")
    }

  public val preset: Unit
    get() {
      writer.println("preset")
    }

  public val to: Unit
    get() {
      writer.println("to")
    }
}

@GraphKtQuery
public class _EntityQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public fun onArticle(block: _ArticleQuery.() -> Unit) {
    writer.println("... on Article {")
    writer.indent {
      _ArticleQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onContentViewEntity(block: _ContentViewEntityQuery.() -> Unit) {
    writer.println("... on ContentViewEntity {")
    writer.indent {
      _ContentViewEntityQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onEvent(block: _EventQuery.() -> Unit) {
    writer.println("... on Event {")
    writer.indent {
      _EventQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onPerformer(block: _PerformerQuery.() -> Unit) {
    writer.println("... on Performer {")
    writer.indent {
      _PerformerQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onTag(block: _TagQuery.() -> Unit) {
    writer.println("... on Tag {")
    writer.indent {
      _TagQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onThingToDo(block: _ThingToDoQuery.() -> Unit) {
    writer.println("... on ThingToDo {")
    writer.indent {
      _ThingToDoQuery(writer).block()
    }
    writer.println("}")
  }

  public fun onVenue(block: _VenueQuery.() -> Unit) {
    writer.println("... on Venue {")
    writer.indent {
      _VenueQuery(writer).block()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val active: Unit
    get() {
      writer.println("active")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val disabled: Unit
    get() {
      writer.println("disabled")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val endDate: Unit
    get() {
      writer.println("endDate")
    }

  public val endTime: Unit
    get() {
      writer.println("endTime")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val score: Unit
    get() {
      writer.println("score")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }

  public fun children(_selection: _EventQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun contentView(_selection: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _EventQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun related(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("related")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(_selection: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventQueryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val limit: Unit
    get() {
      writer.println("limit")
    }

  public val minScore: Unit
    get() {
      writer.println("minScore")
    }

  public val recentlyAnnounced: Unit
    get() {
      writer.println("recentlyAnnounced")
    }

  public val sort: Unit
    get() {
      writer.println("sort")
    }

  public val tags: Unit
    get() {
      writer.println("tags")
    }

  public val venues: Unit
    get() {
      writer.println("venues")
    }

  public fun dateRange(_selection: _DateRangeQuery.() -> Unit) {
    writer.print("dateRange")
    writer.println(" {")
    writer.indent {
      _DateRangeQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventSearchResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val pageToken: Unit
    get() {
      writer.println("pageToken")
    }

  public fun events(_selection: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventTagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val confidence: Unit
    get() {
      writer.println("confidence")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }
}

@GraphKtQuery
public class _EventUpdateQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val duration: Unit
    get() {
      writer.println("duration")
    }

  public val endDate: Unit
    get() {
      writer.println("endDate")
    }

  public val endTime: Unit
    get() {
      writer.println("endTime")
    }

  public val excluded: Unit
    get() {
      writer.println("excluded")
    }

  public val excludedImages: Unit
    get() {
      writer.println("excludedImages")
    }

  public val excludedTags: Unit
    get() {
      writer.println("excludedTags")
    }

  public val images: Unit
    get() {
      writer.println("images")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val parent: Unit
    get() {
      writer.println("parent")
    }

  public val performers: Unit
    get() {
      writer.println("performers")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val sourceUrl: Unit
    get() {
      writer.println("sourceUrl")
    }

  public val suggestedPerformers: Unit
    get() {
      writer.println("suggestedPerformers")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val time: Unit
    get() {
      writer.println("time")
    }

  public val venue: Unit
    get() {
      writer.println("venue")
    }

  public fun eventTags(_selection: _EventTagQuery.() -> Unit) {
    writer.print("eventTags")
    writer.println(" {")
    writer.indent {
      _EventTagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _EventsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun event(id: ID, _selection: _EventQuery.() -> Unit) {
    writer.print("event")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun recentlyActive(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("recentlyActive")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun recentlyActiveByStream(
    stream: EventStream,
    input: EventSearch,
    _selection: _EventSearchResultsQuery.() -> Unit,
  ) {
    writer.print("recentlyActiveByStream")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("stream: ${'$'}")
    writer.print(writer.variable("stream", "EventStream!", serializer<EventStream>(), stream))
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun search(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("search")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _GPSCoordinatesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val latitude: Unit
    get() {
      writer.println("latitude")
    }

  public val longitude: Unit
    get() {
      writer.println("longitude")
    }
}

@GraphKtQuery
public class _GlobalSearchResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun events(_selection: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun results(_selection: _EntityQuery.() -> Unit) {
    writer.print("results")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venues(_selection: _VenueQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _HoursOverrideQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val closed: Unit
    get() {
      writer.println("closed")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val note: Unit
    get() {
      writer.println("note")
    }

  public fun ranges(_selection: _OpenRangeQuery.() -> Unit) {
    writer.print("ranges")
    writer.println(" {")
    writer.indent {
      _OpenRangeQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ImageQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val height: Unit
    get() {
      writer.println("height")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val uri: Unit
    get() {
      writer.println("uri")
    }

  public val variant: Unit
    get() {
      writer.println("variant")
    }

  public val width: Unit
    get() {
      writer.println("width")
    }

  public fun large(_selection: _ImageQuery.() -> Unit) {
    writer.print("large")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun medium(_selection: _ImageQuery.() -> Unit) {
    writer.print("medium")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun small(_selection: _ImageQuery.() -> Unit) {
    writer.print("small")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun variants(input: VariantInput, _selection: _ImageQuery.() -> Unit) {
    writer.print("variants")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "VariantInput!", serializer<VariantInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun withWidth(width: Int, _selection: _ImageQuery.() -> Unit) {
    writer.print("withWidth")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("width: ${'$'}")
    writer.print(writer.variable("width", "Int!", width))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _InteractionSummaryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val liked: Unit
    get() {
      writer.println("liked")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }
}

@GraphKtQuery
public class _LoaderExecutionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val events: Unit
    get() {
      writer.println("events")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }
}

@GraphKtQuery
public class _LogEventQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val message: Unit
    get() {
      writer.println("message")
    }

  public val ts: Unit
    get() {
      writer.println("ts")
    }
}

@GraphKtQuery
public class _LogQueryFieldQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val `field`: Unit
    get() {
      writer.println("field")
    }

  public val `value`: Unit
    get() {
      writer.println("value")
    }
}

@GraphKtQuery
public class _LogQueryResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public fun rows(_selection: _LogQueryRowQuery.() -> Unit) {
    writer.print("rows")
    writer.println(" {")
    writer.indent {
      _LogQueryRowQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun statistics(_selection: _LogQueryStatisticsQuery.() -> Unit) {
    writer.print("statistics")
    writer.println(" {")
    writer.indent {
      _LogQueryStatisticsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogQueryRowQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun fields(_selection: _LogQueryFieldQuery.() -> Unit) {
    writer.print("fields")
    writer.println(" {")
    writer.indent {
      _LogQueryFieldQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _LogQueryStatisticsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val recordsMatched: Unit
    get() {
      writer.println("recordsMatched")
    }

  public val recordsScanned: Unit
    get() {
      writer.println("recordsScanned")
    }
}

@GraphKtQuery
public class _MutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun accounts(_selection: _AccountsQuery.() -> Unit) {
    writer.print("accounts")
    writer.println(" {")
    writer.indent {
      _AccountsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun admin(_selection: _AdminMutationQuery.() -> Unit) {
    writer.print("admin")
    writer.println(" {")
    writer.indent {
      _AdminMutationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun clientSupport(_selection: _ClientSupportQuery.() -> Unit) {
    writer.print("clientSupport")
    writer.println(" {")
    writer.indent {
      _ClientSupportQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun subscriptions(_selection: _SubscriptionsMutatorQuery.() -> Unit) {
    writer.print("subscriptions")
    writer.println(" {")
    writer.indent {
      _SubscriptionsMutatorQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _OnboardingQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun prefSelection(_selection: _OnboardingPrefQuery.() -> Unit) {
    writer.print("prefSelection")
    writer.println(" {")
    writer.indent {
      _OnboardingPrefQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _OnboardingPrefQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val title: Unit
    get() {
      writer.println("title")
    }

  public fun entities(_selection: _EntityQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _OpenIntervalQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val end: Unit
    get() {
      writer.println("end")
    }

  public val start: Unit
    get() {
      writer.println("start")
    }
}

@GraphKtQuery
public class _OpenRangeQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val durationMinutes: Unit
    get() {
      writer.println("durationMinutes")
    }

  public val `open`: Unit
    get() {
      writer.println("open")
    }
}

@GraphKtQuery
public class _OpeningHoursQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val notes: Unit
    get() {
      writer.println("notes")
    }

  public fun openOn(date: AWSDate, _selection: _OpenIntervalQuery.() -> Unit) {
    writer.print("openOn")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("date: ${'$'}")
    writer.print(writer.variable("date", "AWSDate!", LocalDateIso8601Serializer, date))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _OpenIntervalQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun overrides(_selection: _HoursOverrideQuery.() -> Unit) {
    writer.print("overrides")
    writer.println(" {")
    writer.indent {
      _HoursOverrideQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun weekly(_selection: _WeeklyHoursQuery.() -> Unit) {
    writer.print("weekly")
    writer.println(" {")
    writer.indent {
      _WeeklyHoursQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PanelSourceQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val deduplicate: Unit
    get() {
      writer.println("deduplicate")
    }

  public val entityType: Unit
    get() {
      writer.println("entityType")
    }

  public val limit: Unit
    get() {
      writer.println("limit")
    }

  public val manual: Unit
    get() {
      writer.println("manual")
    }

  public val minimum: Unit
    get() {
      writer.println("minimum")
    }

  public val mode: Unit
    get() {
      writer.println("mode")
    }

  public val sort: Unit
    get() {
      writer.println("sort")
    }

  public fun eventQueries(_selection: _EventQueryQuery.() -> Unit) {
    writer.print("eventQueries")
    writer.println(" {")
    writer.indent {
      _EventQueryQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun eventQuery(_selection: _EventQueryQuery.() -> Unit) {
    writer.print("eventQuery")
    writer.println(" {")
    writer.indent {
      _EventQueryQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun related(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("related")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val nextToken: Unit
    get() {
      writer.println("nextToken")
    }

  public fun performers(_selection: _PerformerQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _PerformerUpdateQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val aliases: Unit
    get() {
      writer.println("aliases")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val images: Unit
    get() {
      writer.println("images")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val rankingScore: Unit
    get() {
      writer.println("rankingScore")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val tags: Unit
    get() {
      writer.println("tags")
    }

  public val wikiIdentifier: Unit
    get() {
      writer.println("wikiIdentifier")
    }
}

@GraphKtQuery
public class _PerformersQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun performer(id: ID, _selection: _PerformerQuery.() -> Unit) {
    writer.print("performer")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _PerformerQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun search(input: PerformerSearch, _selection: _PerformerResultsQuery.() -> Unit) {
    writer.print("search")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "PerformerSearch!", serializer<PerformerSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _PerformerResultsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _QueryQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val permissions: Unit
    get() {
      writer.println("permissions")
    }

  public fun articles(_selection: _ArticlesQuery.() -> Unit) {
    writer.print("articles")
    writer.println(" {")
    writer.indent {
      _ArticlesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun auxContent(_selection: _AuxContentQuery.() -> Unit) {
    writer.print("auxContent")
    writer.println(" {")
    writer.indent {
      _AuxContentQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun clientSupport(_selection: _ClientSupportQuery.() -> Unit) {
    writer.print("clientSupport")
    writer.println(" {")
    writer.indent {
      _ClientSupportQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun content(_selection: _ContentQuery.() -> Unit) {
    writer.print("content")
    writer.println(" {")
    writer.indent {
      _ContentQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun contentViews(_selection: _ContentViewsQuery.() -> Unit) {
    writer.print("contentViews")
    writer.println(" {")
    writer.indent {
      _ContentViewsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun conversations(_selection: _ConversationsQuery.() -> Unit) {
    writer.print("conversations")
    writer.println(" {")
    writer.indent {
      _ConversationsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun entities(path: List<String>, _selection: _EntityQuery.() -> Unit) {
    writer.print("entities")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("path: ${'$'}")
    writer.print(writer.variable("path", "[String!]!", ListSerializer(serializer<String>()), path))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun entity(path: String, _selection: _EntityQuery.() -> Unit) {
    writer.print("entity")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("path: ${'$'}")
    writer.print(writer.variable("path", "String!", path))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(_selection: _EventsQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun performers(_selection: _PerformersQuery.() -> Unit) {
    writer.print("performers")
    writer.println(" {")
    writer.indent {
      _PerformersQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun search(input: GlobalSearchInput, _selection: _GlobalSearchResultsQuery.() -> Unit) {
    writer.print("search")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "GlobalSearchInput!", serializer<GlobalSearchInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _GlobalSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun subscriptions(_selection: _SubscriptionsQuery.() -> Unit) {
    writer.print("subscriptions")
    writer.println(" {")
    writer.indent {
      _SubscriptionsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagsQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun thingsToDo(_selection: _ThingsToDoQuery.() -> Unit) {
    writer.print("thingsToDo")
    writer.println(" {")
    writer.indent {
      _ThingsToDoQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun typeahead(input: GlobalSearchInput, _selection: _GlobalSearchResultsQuery.() -> Unit) {
    writer.print("typeahead")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "GlobalSearchInput!", serializer<GlobalSearchInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _GlobalSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venues(_selection: _VenuesQuery.() -> Unit) {
    writer.print("venues")
    writer.println(" {")
    writer.indent {
      _VenuesQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SocialImageStatusQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val error: Unit
    get() {
      writer.println("error")
    }

  public val state: Unit
    get() {
      writer.println("state")
    }

  public val url: Unit
    get() {
      writer.println("url")
    }
}

@GraphKtQuery
public class _SocialLinkQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val locator: Unit
    get() {
      writer.println("locator")
    }

  public val type: Unit
    get() {
      writer.println("type")
    }
}

@GraphKtQuery
public class _SourceDataSearchResultQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }
}

@GraphKtQuery
public class _SubscriptionQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val date: Unit
    get() {
      writer.println("date")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val interactionType: Unit
    get() {
      writer.println("interactionType")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val subscriber: Unit
    get() {
      writer.println("subscriber")
    }

  public fun target(_selection: _EntityQuery.() -> Unit) {
    writer.print("target")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SubscriptionsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun mine(_selection: _UserSubscriptionsQuery.() -> Unit) {
    writer.print("mine")
    writer.println(" {")
    writer.indent {
      _UserSubscriptionsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun userSubscriptions(userId: String, _selection: _UserSubscriptionsQuery.() -> Unit) {
    writer.print("userSubscriptions")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("userId: ${'$'}")
    writer.print(writer.variable("userId", "String!", userId))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _UserSubscriptionsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _SubscriptionsMutatorQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val buildRecommendations: Unit
    get() {
      writer.println("buildRecommendations")
    }

  public fun clear(input: ClearUserDataInput) {
    writer.print("clear")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ClearUserDataInput!", serializer<ClearUserDataInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun clearInteraction(input: InteractInput) {
    writer.print("clearInteraction")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "InteractInput!", serializer<InteractInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun interact(input: InteractInput) {
    writer.print("interact")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "InteractInput!", serializer<InteractInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun like(input: LikeInput) {
    writer.print("like")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "LikeInput!", serializer<LikeInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun registerDevice(input: DeviceTokenRegistration) {
    writer.print("registerDevice")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "DeviceTokenRegistration!", serializer<DeviceTokenRegistration>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun share(input: ShareInput) {
    writer.print("share")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ShareInput!", serializer<ShareInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }

  public fun subscribe(input: SubscriptionInput, _selection: _SubscriptionQuery.() -> Unit) {
    writer.print("subscribe")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "SubscriptionInput!", serializer<SubscriptionInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun unsubscribe(input: SubscriptionInput) {
    writer.print("unsubscribe")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "SubscriptionInput!", serializer<SubscriptionInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }
}

@GraphKtQuery
public class _SystemMutationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun applicationEvent(input: SystemEventInput) {
    writer.print("applicationEvent")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "SystemEventInput!", serializer<SystemEventInput>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
  }
}

@GraphKtQuery
public class _TagQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val pageTitle: Unit
    get() {
      writer.println("pageTitle")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val personalize: Unit
    get() {
      writer.println("personalize")
    }

  public val shadow: Unit
    get() {
      writer.println("shadow")
    }

  public fun contentView(_selection: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _TagQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _TagsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun root(_selection: _TagQuery.() -> Unit) {
    writer.print("root")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tag(id: ID, _selection: _TagQuery.() -> Unit) {
    writer.print("tag")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(ids: List<ID>, _selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("ids: ${'$'}")
    writer.print(writer.variable("ids", "[ID!]!", ListSerializer(serializer<ID>()), ids))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ThingToDoQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val availability: Unit
    get() {
      writer.println("availability")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val openNow: Unit
    get() {
      writer.println("openNow")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val priceFrom: Unit
    get() {
      writer.println("priceFrom")
    }

  public val score: Unit
    get() {
      writer.println("score")
    }

  public val summary: Unit
    get() {
      writer.println("summary")
    }

  public val tagline: Unit
    get() {
      writer.println("tagline")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public val typicalDuration: Unit
    get() {
      writer.println("typicalDuration")
    }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun hours(_selection: _OpeningHoursQuery.() -> Unit) {
    writer.print("hours")
    writer.println(" {")
    writer.indent {
      _OpeningHoursQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(_selection: _VenueQuery.() -> Unit) {
    writer.print("venue")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ThingToDoResultsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun things(_selection: _ThingToDoQuery.() -> Unit) {
    writer.print("things")
    writer.println(" {")
    writer.indent {
      _ThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ThingsToDoQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun search(input: ThingSearch, _selection: _ThingToDoResultsQuery.() -> Unit) {
    writer.print("search")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "ThingSearch!", serializer<ThingSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ThingToDoResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun thing(id: ID, _selection: _ThingToDoQuery.() -> Unit) {
    writer.print("thing")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _ThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserRecommendationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val score: Unit
    get() {
      writer.println("score")
    }

  public fun entity(_selection: _EntityQuery.() -> Unit) {
    writer.print("entity")
    writer.println(" {")
    writer.indent {
      writer.println("__typename")
      _EntityQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(_selection: _EventQuery.() -> Unit) {
    writer.print("events")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserRecommendationsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun comingUp(_selection: _EventQuery.() -> Unit) {
    writer.print("comingUp")
    writer.println(" {")
    writer.indent {
      _EventQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun entities(_selection: _UserRecommendationQuery.() -> Unit) {
    writer.print("entities")
    writer.println(" {")
    writer.indent {
      _UserRecommendationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun top(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("top")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _UserSubscriptionsQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun calendar(
    start: OptionalInput<AWSDateTime?> = OptionalInput.Absent,
    end: OptionalInput<AWSDateTime?> = OptionalInput.Absent,
    limit: OptionalInput<Int?> = OptionalInput.Absent,
    paginationToken: OptionalInput<String?> = OptionalInput.Absent,
    _selection: _EventSearchResultsQuery.() -> Unit,
  ) {
    writer.print("calendar")
    var _graphKtArgumentWritten = false
    when (val value = start) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("start: ${'$'}")
        writer.print(writer.variable("start", "AWSDateTime", InstantSerializer.nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = end) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("end: ${'$'}")
        writer.print(writer.variable("end", "AWSDateTime", InstantSerializer.nullable, value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = limit) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("limit: ${'$'}")
        writer.print(writer.variable("limit", "Int", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    when (val value = paginationToken) {
      is OptionalInput.Present -> {
        if (_graphKtArgumentWritten) {
          writer.print(", ")
        } else {
          writer.print("(")
          _graphKtArgumentWritten = true
        }
        writer.print("paginationToken: ${'$'}")
        writer.print(writer.variable("paginationToken", "String", value.value))
      }
      OptionalInput.Absent -> Unit
    }
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun interactionSummary(entityPath: String, _selection: _InteractionSummaryQuery.() -> Unit) {
    writer.print("interactionSummary")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("entityPath: ${'$'}")
    writer.print(writer.variable("entityPath", "String!", entityPath))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _InteractionSummaryQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun interactions(type: InteractionType, _selection: _SubscriptionQuery.() -> Unit) {
    writer.print("interactions")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("type: ${'$'}")
    writer.print(writer.variable("type", "InteractionType!", serializer<InteractionType>(), type))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun interactionsWithEntity(entityPath: String, _selection: _SubscriptionQuery.() -> Unit) {
    writer.print("interactionsWithEntity")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("entityPath: ${'$'}")
    writer.print(writer.variable("entityPath", "String!", entityPath))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _SubscriptionQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun recommendations(_selection: _UserRecommendationsQuery.() -> Unit) {
    writer.print("recommendations")
    writer.println(" {")
    writer.indent {
      _UserRecommendationsQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _VenueQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val description: Unit
    get() {
      writer.println("description")
    }

  public val eventStream: Unit
    get() {
      writer.println("eventStream")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public val name: Unit
    get() {
      writer.println("name")
    }

  public val parking: Unit
    get() {
      writer.println("parking")
    }

  public val path: Unit
    get() {
      writer.println("path")
    }

  public val redirect: Unit
    get() {
      writer.println("redirect")
    }

  public val status: Unit
    get() {
      writer.println("status")
    }

  public val ticketsUrl: Unit
    get() {
      writer.println("ticketsUrl")
    }

  public fun address(_selection: _AddressQuery.() -> Unit) {
    writer.print("address")
    writer.println(" {")
    writer.indent {
      _AddressQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun children(_selection: _VenueQuery.() -> Unit) {
    writer.print("children")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun contentView(_selection: _ViewConfigurationQuery.() -> Unit) {
    writer.print("contentView")
    writer.println(" {")
    writer.indent {
      _ViewConfigurationQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun events(input: EventSearch, _selection: _EventSearchResultsQuery.() -> Unit) {
    writer.print("events")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("input: ${'$'}")
    writer.print(writer.variable("input", "EventSearch!", serializer<EventSearch>(), input))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _EventSearchResultsQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun images(_selection: _ImageQuery.() -> Unit) {
    writer.print("images")
    writer.println(" {")
    writer.indent {
      _ImageQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun links(_selection: _SocialLinkQuery.() -> Unit) {
    writer.print("links")
    writer.println(" {")
    writer.indent {
      _SocialLinkQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun location(_selection: _GPSCoordinatesQuery.() -> Unit) {
    writer.print("location")
    writer.println(" {")
    writer.indent {
      _GPSCoordinatesQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun parent(_selection: _VenueQuery.() -> Unit) {
    writer.print("parent")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun tags(_selection: _TagQuery.() -> Unit) {
    writer.print("tags")
    writer.println(" {")
    writer.indent {
      _TagQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun thingsToDo(_selection: _ThingToDoQuery.() -> Unit) {
    writer.print("thingsToDo")
    writer.println(" {")
    writer.indent {
      _ThingToDoQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _VenuesQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public fun root(_selection: _VenueQuery.() -> Unit) {
    writer.print("root")
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }

  public fun venue(id: ID, _selection: _VenueQuery.() -> Unit) {
    writer.print("venue")
    var _graphKtArgumentWritten = false
    if (_graphKtArgumentWritten) {
      writer.print(", ")
    } else {
      writer.print("(")
      _graphKtArgumentWritten = true
    }
    writer.print("id: ${'$'}")
    writer.print(writer.variable("id", "ID!", id))
    if (_graphKtArgumentWritten) {
      writer.print(")")
    }
    writer.println(" {")
    writer.indent {
      _VenueQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _ViewConfigurationQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val id: Unit
    get() {
      writer.println("id")
    }

  public fun panels(_selection: _ContentPanelQuery.() -> Unit) {
    writer.print("panels")
    writer.println(" {")
    writer.indent {
      _ContentPanelQuery(it)._selection()
    }
    writer.println("}")
  }
}

@GraphKtQuery
public class _WeeklyHoursQuery(
  private val writer: QueryWriter,
) {
  public val __typename: Unit
    get() {
      writer.println("__typename")
    }

  public val days: Unit
    get() {
      writer.println("days")
    }

  public fun ranges(_selection: _OpenRangeQuery.() -> Unit) {
    writer.print("ranges")
    writer.println(" {")
    writer.indent {
      _OpenRangeQuery(it)._selection()
    }
    writer.println("}")
  }
}

public suspend fun GraphQLClient.query(name: String? = null, block: _QueryQuery.() -> Unit): Query {
  val result = executeAndParse(name, json, ::QueryResponse) {
    this.type = "query"
    _QueryQuery(this).block()
  }
  return result
}

public suspend fun GraphQLClient.mutation(name: String? = null, block: _MutationQuery.() -> Unit): Mutation {
  val result = executeAndParse(name, json, ::MutationResponse) {
    this.type = "mutation"
    _MutationQuery(this).block()
  }
  return result
}
